import * as React from "react";
import "./uploadImage.css";
import {
  formatFileName,
  validateNewFileSelection,
} from "../../../utils/fileUploadUtils";
import IconAlertIcon from "../../../assets/svgs/icon-alert.svg";
import CloseIcon from "../../../assets/svgs/CloseSucess.svg";
import UploadIcon from "../../../assets/svgs/uploadFile.svg";
import Notification from "../../fluxo-tax/Notification/notification";
import { Button, styled } from "@mui/material";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
});

interface UploadImageProps {
  onFilesSelected: (files: File[]) => void;
  selectedFiles?: any;
  setSelectedFiles?: any;
}

const UploadImage = ({
  onFilesSelected,
  selectedFiles,
  setSelectedFiles,
}: UploadImageProps) => {
  const constMaxImgSize = 5 * 1024 * 1024;
  const maxFiles = 5;
  const acceptedImageTypes = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "application/pdf",
  ];

  const [errorMessage, setErrorMessage] = React.useState<string | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files) return;

    const newFiles = Array.from(files);

    const { errorMessage: validationError, validFiles } =
      validateNewFileSelection(
        newFiles,
        selectedFiles,
        maxFiles,
        constMaxImgSize,
        acceptedImageTypes
      );

    if (validationError) {
      setErrorMessage(validationError);

      setTimeout(() => {
        setErrorMessage(null);
      }, 8000);

      event.target.value = "";
      return;
    }
    setSelectedFiles((prevFiles: any) => {
      const updatedFiles = [...prevFiles, ...validFiles];
      onFilesSelected(updatedFiles);
      return updatedFiles;
    });
    event.target.value = "";
  };

  const handleRemoveSelectedFile = (indexToRemove: number) => {
    setSelectedFiles((prevFiles: any) => {
      const updated = prevFiles.filter(
        (_: any, index: any) => index !== indexToRemove
      );
      onFilesSelected(updated);
      return updated;
    });
  };

  return (
    <div style={{ width: "auto" }}>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<img src={UploadIcon} alt="icone de upload de imagem" />}
          sx={{
            marginRight: "10px",
            marginBottom: "10px",
            borderRadius: "0px !important",
            backgroundColor: "transparent ",
            boxShadow: "none !important",
            border: "1px solid #007bc0 !important",
            color: " #007bc0 !important",
            width: " 180px !important",
            height: "55px",
            padding: " 0px 17px 0px 12px !important",
            textTransform: "none !important",
            "&:hover": {
              backgroundColor: "#D1E4FF !important",
            },
          }}
          className="uploadImage"
        >
          Escolher arquivos
          <VisuallyHiddenInput
            type="file"
            onChange={handleFileChange}
            multiple
            accept={acceptedImageTypes.join(",")}
          />
        </Button>
        {selectedFiles?.length === 0 && (
          <p className="placeMenssage">Nenhum arquivo selecionado</p>
        )}

        {selectedFiles?.length > 0 && (
          <div className="ImgItenContainer">
            {selectedFiles.map((file: any, index: any) => (
              <div key={file.name} className="ImgIten tooltipWrapper">
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    justifyContent: "center",
                  }}
                >
                  {formatFileName(file.name)}
                  &nbsp;
                  <span style={{ color: "grey" }}>
                    ({(file.size / (1024 * 1024)).toFixed(1)} MB)
                  </span>
                  <button
                    type="button"
                    onClick={() => handleRemoveSelectedFile(index)}
                    aria-label="Retirar imagem escolhida"
                    className="iconButton"
                    style={{
                      marginLeft: 5,
                      width: 12,
                    }}
                  >
                    <img
                      src={CloseIcon}
                      alt="Retirar imagem escolhida"
                      style={{ width: "100%", cursor: "pointer" }}
                    />
                  </button>
                </span>
                <div className="tooltipBox">
                  {file.name} - {(file.size / (1024 * 1024)).toFixed(1)} MB
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {errorMessage && (
        <div className="AlertImagetPosition">
          <Notification
            classNameAux="justifyText"
            label={errorMessage}
            backgroundError="#FFD9D9"
            widthError="385px"
            img={IconAlertIcon}
            setNotification={setErrorMessage}
          />
        </div>
      )}
    </div>
  );
};

export default UploadImage;
